// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"380":"0dbdde383db0ec4a913a","415":"3c3d7e661fb95b5b02eb","618":"ca366489c7cd3026b1d2","944":"5a7531df74110bfa45b5"}[chunkId] + ".js";
};